export default __webpack_public_path__ + "static/media/info.16010bb1.svg";